import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  min-height: 0;

  .tasks-list {
    min-width: 0;
  }

  .task-pane {
    width: 480px;
    max-width: 50%;
    min-height: 0;
  }

  .task-pane > h4,
  .task-pane .material-icons {
    color: ${(props) => props.theme.$dark};
  }

  .task-pane-delete .material-icons {
    color: ${(props) => props.theme.$danger};
  }

  .task-pane-header .material-icons {
    font-size: 24px;
  }

  .task-row {
    border-radius: 8px;
    text-align: left;
    cursor: pointer;
    transition: box-shadow 0.15s ease, border-color 0.15s ease;
  }

  .task-row:hover,
  .task-row:focus {
    box-shadow: 0 2px 8px ${(props) => props.theme.$black}14;
    outline: 0;
  }

  .task-row-active {
    border-color: ${(props) => props.theme.$success};
  }

  .min-width-0 {
    min-width: 0;
  }

  .task-title {
    color: ${(props) => props.theme.$dark};
  }

  .task-count {
    padding: 0 6px;
    color: ${(props) => props.theme.$gray700};
  }

  .tasks-empty {
    max-width: 720px;
  }

  .tasks-empty-title {
    font-size: 20px;
  }

  .tasks-empty-link {
    vertical-align: baseline;
    font-size: inherit;
  }

  .material-icons {
    font-size: 16px;
  }
`;
